import { AxiosError } from 'axios';
import { $api } from './interceptor';
import { toast } from 'App';
import { RevenueResponse, RevenueApiResponse } from 'types/revenue';

export interface RevenueParams {
  startDate?: string;
  endDate?: string;
}

const RevenueService = () => {
  const getRevenueData = async (
    params: RevenueParams
  ): Promise<RevenueResponse> => {
    try {
      const searchParams = new URLSearchParams();

      if (params.startDate) {
        searchParams.append('startDate', params.startDate);
      }
      if (params.endDate) {
        searchParams.append('endDate', params.endDate);
      }

      const { data } = await $api.get<RevenueApiResponse>(
        `api/admins/get-base-fee-stats?${searchParams.toString()}`
      );

      const transactions = data;
      const totalFeesSol = transactions.reduce(
        (acc, tx) => acc + tx.baseFeeSol,
        0
      );

      const solToUsdRate = await getCurrentSolPrice();

      return {
        data: transactions,
        totalFeesSol,
        solToUsdRate,
        totalItems: transactions.length,
      };
    } catch (e) {
      console.log(e);
      if (e instanceof AxiosError) {
        toast({
          title: 'Error',
          description:
            e.response?.data?.message || 'Failed to fetch revenue data',
          status: 'error',
          position: 'top-right',
        });
      } else {
        toast({
          title: 'Error fetching revenue data',
          status: 'error',
          isClosable: true,
          position: 'top-right',
        });
      }
      throw e;
    }
  };

  const getCurrentSolPrice = async (): Promise<number> => {
    try {
      // Fetch SOL price from Jupiter API
      const response = await fetch(
        'https://lite-api.jup.ag/price/v3?ids=So11111111111111111111111111111111111111112'
      );
      if (!response.ok) {
        throw new Error('Failed to fetch SOL price');
      }

      const data = await response.json();
      const solPrice =
        data?.So11111111111111111111111111111111111111112?.usdPrice;

      return solPrice;
    } catch (e) {
      console.log(e);
      return 200; // fallback
    }
  };

  return {
    getRevenueData,
    getCurrentSolPrice,
  };
};

export const revenueService = RevenueService();
